import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'FETCH_ALL',
    'FETCH_SUCCESS',
    'FETCH_ALL_CALLOUTS',
    'FETCH_CALLOUTS_SUCCESS',
    'FETCH_PLACEMENT',
    'FETCH_PLACEMENT_SUCCESS',
    'RESET_TO_INITIAL_STATE'
], 'TACTICS');


// Action Creators
export const fetchTactics = createAction(actions.FETCH_ALL, params => params);
export const tacticsFetched = createAction(actions.FETCH_SUCCESS, data => data);
export const fetchTacticPlacements = createAction(actions.FETCH_PLACEMENT, data => data);
export const tacticPlacementsFetch = createAction(actions.FETCH_PLACEMENT_SUCCESS, data => data);
export const resetTacticsInitialState = createAction(actions.RESET_TO_INITIAL_STATE);

// Reducers
const initialState = {
    keys: null,
    callouts: null,
    data: null,
    groupedData: null,
    insights: null,
    xAxisLabel: null,
    statistics: null,
    categories: null,
    apiConfig: null,
    placements: null,
    hasData: null
};

export default handleActions({

    [actions.FETCH_SUCCESS]: (state, action) => {
        const hasData = action.payload.params.hasData;

        if (hasData) {
            // All channels have the same set of mertics returned.
            const metricKeys = Object.keys(action.payload[action.payload.channels[0]].statistics);

            const rootState = action.getState();
            const scopeKey = action.payload.categories.config.selector;
            const data = {};
            const groupedData = {};
            const insights = metricKeys.reduce((prev, key) => {
                prev.percentages[key] = {};
                prev.totals[key] = 0;
                return prev;
            }, { percentages: {}, totals: {} });

            action.payload.tactics.forEach((tactic) => {
                data[tactic] = {
                    statistics: action.payload[tactic].statistics,
                    items: action.payload[tactic][scopeKey]
                };
                groupedData[tactic] = action.payload[tactic][scopeKey];
                metricKeys.forEach((key) => {
                    insights.totals[key] += action.payload[tactic].statistics[key];
                });
            });

            // Generate percentages
            action.payload.tactics.forEach((tactic) => {
                const stats = data[tactic].statistics;
                const totals = insights.totals;

                Object.keys(insights.percentages).forEach((metric) => {
                    insights.percentages[metric][tactic] = (stats[metric] / totals[metric]) * 100;
                });
            });

            const updatedData = {
                keys: { $set: action.payload.tactics },
                data: { $set: data },
                groupedData: { $set: groupedData },
                insights: { $set: insights },
                statistics: { $set: action.payload.statistics },
                categories: { $set: action.payload.categories[scopeKey] },
                xAxisLabel: { $set: action.payload.categories.config.xAxisLabel },
                apiConfig: { $set: rootState.config.selectedTimeRange.apiConfig },
                hasData: { $set: hasData }
            };
            return update(state, updatedData);
        }

        const updatedData = {
            hasData: { $set: hasData }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_PLACEMENT_SUCCESS]: (state, action) => {
        const placements = action.payload;
        const updatedData = {
            placements: { $set: placements }
        };
        return update(state, updatedData);
    },

    [actions.RESET_TO_INITIAL_STATE]: state => update(state, { $set: initialState })

}, initialState);



// WEBPACK FOOTER //
// ./src/services/tactics/duck.js